// extracted by mini-css-extract-plugin
export default {"wrapper":"Qmn9PBsdqq","focus":"JbTis1Oj3F","read-only":"Ke6fkvRVRN","readOnly":"Ke6fkvRVRN"};